import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function SmsMarketing() {
  return (
    <>
      <Helmet>
        <title>Customer Notification Services - A2P 10DLC Compliant | RMQ Digital</title>
        <meta name="description" content="Professional customer notification services with A2P 10DLC compliance. Appointment reminders, service alerts, and account notifications." />
      </Helmet>

      <div style={{ background: 'linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%)', color: 'white', padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem' }}>Customer Notification Services</h1>
          <p style={{ fontSize: '1.25rem', opacity: 0.95 }}>A2P 10DLC compliant appointment reminders and service alerts for your business</p>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 2rem' }}>
        {/* SMS Service Image */}
        <div style={{ marginBottom: '4rem', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.1)' }}>
          <img 
            src="https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=1200&h=400&fit=crop" 
            alt="Mobile notifications and messaging" 
            style={{ width: '100%', height: '400px', objectFit: 'cover' }}
          />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginBottom: '4rem' }}>
          <div style={{ background: 'white', padding: '2rem', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📱</div>
            <h3 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '1rem' }}>
              Customer Notifications
            </h3>
            <p style={{ color: '#6b7280', lineHeight: '1.6' }}>
              Send appointment reminders, service updates, and account alerts instantly. Perfect for customer service and account management.
            </p>
          </div>

          <div style={{ background: 'white', padding: '2rem', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✓</div>
            <h3 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '1rem' }}>
              A2P 10DLC Compliant
            </h3>
            <p style={{ color: '#6b7280', lineHeight: '1.6' }}>
              Fully registered with The Campaign Registry. Carrier-approved messaging with high deliverability rates (99%+).
            </p>
          </div>

          <div style={{ background: 'white', padding: '2rem', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔄</div>
            <h3 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '1rem' }}>
              Two-Way Messaging
            </h3>
            <p style={{ color: '#6b7280', lineHeight: '1.6' }}>
              Enable conversations with your customers. Automated responses for HELP, STOP, and custom keywords.
            </p>
          </div>
        </div>

        <div style={{ background: '#f9fafb', padding: '3rem', borderRadius: '12px', marginBottom: '4rem' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#1f2937', marginBottom: '2rem', textAlign: 'center' }}>
            Features & Benefits
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem' }}>
            {[
              'High deliverability (99%+)',
              'Real-time delivery tracking',
              'Automated opt-out management',
              'Scheduled messaging',
              'Contact list management',
              'Message templates',
              'Analytics & reporting',
              'API integration',
              'TCPA compliance tools',
              'Dedicated support'
            ].map((feature, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span style={{ color: '#6d28d9', fontWeight: '600' }}>✓</span>
                <span style={{ color: '#4b5563' }}>{feature}</span>
              </div>
            ))}
          </div>
        </div>

        <div style={{ background: 'linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%)', color: 'white', padding: '3rem', borderRadius: '12px', textAlign: 'center' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '1rem' }}>
            Ready to Improve Customer Communication?
          </h2>
          <p style={{ fontSize: '1.1rem', marginBottom: '2rem', opacity: 0.95 }}>
            Get started with professional customer notifications today
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/contact" style={{
              display: 'inline-block',
              background: 'white',
              color: '#6d28d9',
              padding: '1rem 2rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              transition: 'all 0.3s ease'
            }}>
              Get Started
            </Link>
            <Link to="/pricing" style={{
              display: 'inline-block',
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              border: '2px solid white',
              transition: 'all 0.3s ease'
            }}>
              View Pricing
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
